import { constants, typographyStyles } from "@newsela/angelou";

import { AssignModalZIndex } from "@/view/AssignModal/AssignModal.style";

const viewPageZIndex = AssignModalZIndex;
const { ui } = constants.colors;
const { fontSize } = typographyStyles;
const green500 = ui.green[500];
const neutral400 = ui.neutral[400];
const red500 = ui.red[500];
const white50 = ui.white[50];

export const bubbleMenuButtonStyle = {
  root: {
    transform: "translateY(8px)",
  },
};

export const bubbleMenuStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  border: `1px solid ${neutral400}`,
  borderRadius: "4px",
  padding: "8px",
  width: "336px",
  backgroundColor: white50,
};

export const inputStyle = {
  input: {
    paddingLeft: "8px",
    height: "24px",
    ...fontSize.textS,
  },
};

export const linkButtonModalStyle = {
  root: {
    zIndex: viewPageZIndex,
  },
  footer: {
    display: "flex",
    gap: "1rem",
    justifyContent: "flex-end",
  },
  modalContentWrapper: {
    height: "auto",
  },
};

export const removeIconStyle = {
  root: {
    path: {
      "--angelou-svg-primary-color": red500,
    },
  },
};

export const saveIconStyle = {
  root: {
    path: {
      "--angelou-svg-primary-color": green500,
    },
  },
};
